export default {
      id: "preview-usage",
      viewBox: "0 0 30 30",
      url: "/assets/" + "icons.svg#preview",
      toString: function () {
        return this.url;
      }
    }